import { QuickRange, RefreshInterval } from "./types";
import { sub } from "./date"

export enum LanguageEnum {
  pl = "pl",
  en = "en",
}

export const QUICK_RANGES: QuickRange[] = [
  { key: "last-5m",  label: "Last 5 minutes",  from: () => sub(new Date(), 5   * 60_000),     to: () => new Date() },
  { key: "last-15m", label: "Last 15 minutes", from: () => sub(new Date(), 15  * 60_000),     to: () => new Date() },
  { key: "last-30m", label: "Last 30 minutes", from: () => sub(new Date(), 30  * 60_000),     to: () => new Date() },
  { key: "last-1h",  label: "Last 1 hour",     from: () => sub(new Date(), 60  * 60_000),     to: () => new Date() },
  { key: "last-3h",  label: "Last 3 hours",    from: () => sub(new Date(), 3   * 3_600_000),  to: () => new Date() },
  { key: "last-6h",  label: "Last 6 hours",    from: () => sub(new Date(), 6   * 3_600_000),  to: () => new Date() },
  { key: "last-12h", label: "Last 12 hours",   from: () => sub(new Date(), 12  * 3_600_000),  to: () => new Date() },
  { key: "last-24h", label: "Last 24 hours",   from: () => sub(new Date(), 24  * 3_600_000),  to: () => new Date() },
  { key: "last-2d",  label: "Last 2 days",     from: () => sub(new Date(), 2   * 86_400_000), to: () => new Date() },
  { key: "last-7d",  label: "Last 7 days",     from: () => sub(new Date(), 7   * 86_400_000), to: () => new Date() },
  { key: "last-30d", label: "Last 30 days",    from: () => sub(new Date(), 30  * 86_400_000), to: () => new Date() },
];

export const REFRESH_INTERVALS: RefreshInterval[] = [
  { label: "Off",  ms: null },
  { label: "5s",   ms: 5_000 },
  { label: "10s",  ms: 10_000 },
  { label: "30s",  ms: 30_000 },
  { label: "1m",   ms: 60_000 },
  { label: "5m",   ms: 300_000 },
  { label: "15m",  ms: 900_000 },
  { label: "30m",  ms: 1_800_000 },
  { label: "1h",   ms: 3_600_000 },
  { label: "2h",   ms: 7_200_000 },
  { label: "1d",   ms: 86_400_000 },
];